import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-agendado-realizado`

    return {
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
    }
}
